import axiosInstance from "./axiosConfig";
import application from "../data/application.json";
import {isPropRef, prop, propId} from "../utils/metaUtil";

const convertData = (meta, entityType, entity) => {
    const entityFinal=entity;
  Object.keys(entity).map(e=>{
      if (isPropRef(meta, entityType, e)) {
          const val={};
          val[propId(meta, e)]=entity[e];
          entityFinal[e]=val;
      }
  });
  return entityFinal;
};
export default {
    auth: {
        login: credentials =>
            axiosInstance[application.auth.method]
                (application.auth.endpoint, {
                    email: credentials.email,
                    password: credentials.password
                })
                .then(res=>res.data),
    },

    get: endpointUrl =>
        axiosInstance
            .get(endpointUrl)
            .then((res=>res.data)),

    post: (meta, endpointUrl, entityType, entity) =>
        axiosInstance
            .post(endpointUrl, convertData(meta, entityType, entity))
            .then((res=>res.data)),

    put: (meta, endpointUrl, entityType, entity) =>
        axiosInstance
            .put(endpointUrl, convertData(meta, entityType, entity))
            .then((res=>res.data))
}


// WEBPACK FOOTER //
// ./src/middleware/api.js